import { useEffect } from "react";

export const useOnPasteTextCleaner = () => {
  useEffect(() => {
    const onPaste = async (e) => {
      if (e instanceof ClipboardEvent) {
        const text = await navigator.clipboard
          .readText()
          .then((clipText) => clipText);

        const inputElement = e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement ? e.target : null;
        if (inputElement !== null) {
          if (inputElement.closest('[data-paste-cleaner-ignore="true"]')) return;

          const regex = /[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ.,;:?!'"()\\[\]{}\s\-$%&*/+=@#|<>]/g;
          Object.getOwnPropertyDescriptor(
            Object.getPrototypeOf(inputElement), 'value')!
            .set!.call(inputElement, text.replace(regex, ''));
          const event = new Event('change', { bubbles: true });
          inputElement!.dispatchEvent(event);
        }
      }
    };
    window.addEventListener('paste', onPaste);

    return () => {
      window.removeEventListener("paste", onPaste);
    };
  }, []);
};
